module.exports = __webpack_public_path__ + "static/media/pawan-rai.a740c8d8.jpg";